import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';
import { ApplicationTypes } from 'projects/admin/src/app/models/exemptionFilling';
import { forkJoin } from 'rxjs';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../../shared/services/external.common.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateComponent implements OnInit {
  requestType = '';
  applicationType = '';
  appTypes = ['intial', 'renewal', 'requestcopy'];
  form!: FormGroup;
  fillingTypes: DropdownItem[] = [];
  requestTypes: DropdownItem[] = [];
  docTypeList: DropdownItem[] = [];
  doctypeControl = new FormControl([]);
  registrationControlNumber = new FormControl([]);
  recaptcha = new FormControl('', Validators.required);
  isConstrution = false;
  isRegValidated = false;
  errorMsg = '';
  regRequired = [
    'renewal',
    'subsequent',
    'renewalsubsequent',
    'subsequentreinstatement',
    'voluntaryrevocation',
    'requestcopy',
    'corrections',
  ];
  regText = 'Registration Control #';
  pendingInternalStatus: any;
  pendingExternalStatus: any;
  isContinueClicked = false;
  registryDownload = 'registryDownload'
  constructor(
    private routerService: Router,
    private router: ActivatedRoute,
    private commonService: ExternalCommonService,
    private formBuilder: FormBuilder,
    private exemptionFillingService: ExternalFilingRequestService
  ) {
    this.commonService.getConstructionTypes().subscribe((res) => {
      this.docTypeList = res;
    });
    this.commonService.getRequestTypes().subscribe((res) => {
      this.requestTypes = res;
    });
    this.commonService.geFillingTypes().subscribe((res) => {
      this.fillingTypes = res;
    });
  }


  getRequestType() {
    let atype = this.applicationType;
    let requesttype = '';
    if (['intial'].includes(atype)) requesttype = 'intial';
    if (['voluntaryrevocation', 'requestcopy'].includes(atype))
      requesttype = 'requestcopy';
    if (
      [
        'renewal',
        'subsequent',
        'reinstatement',
        'corrections',
        'renewalsubsequent',
        'subsequentreinstatement',
      ].includes(atype)
    )
      requesttype = 'renewal';
    return requesttype;
  }

  getRequestRoute() {
    let atype = this.applicationType;
    let requesttype = '';
    if (['intial', 'corrections', 'subsequent'].includes(atype)) requesttype = 'initial';
    if (['voluntaryrevocation', 'requestcopy'].includes(atype))
      requesttype = 'requestcopy';
    if (
      [
        'renewal',
        'reinstatement',
        'renewalsubsequent',
        'subsequentreinstatement',
      ].includes(atype)
    )
      requesttype = 'renewal';
    return requesttype;
  }

  ngOnInit(): void {
    forkJoin({
      reqT: this.commonService.getRequestStatusTypes(),
      externalT: this.commonService.getExternalStatusTypes(),
    }).subscribe(({ reqT, externalT }) => {
      this.pendingInternalStatus = reqT.find(
        (x: { code: string }) => x.code == 'PENDING'
      )?.id;
      this.pendingExternalStatus = externalT.find(
        (x: { code: string }) => x.code == 'PENDING'
      )?.id;
    });
    try {
      this.applicationType = atob(this.router.snapshot.params.type);
      if (this.applicationType == this.registryDownload) {
        this.commonService.addRegistryDownload()
        .subscribe(
          (res) => {
            console.log(res);
              this.routerService.navigate(
                ['/registrydownload', btoa(res?.id)]
              );
          },
          (error) => {
            console.log(error);
          }
        );

      } else {
        this.requestType = this.getRequestType();
      }
    } catch (e) {
    } finally {
      // if (!this.appTypes.includes(this.requestType)) {
      //   window.location.href =
      //     'https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry.html';
      // }
    }
    if (
      this.applicationType == 'subsequent' ||
      this.applicationType == 'renewalsubsequent' || this.applicationType == 'subsequentreinstatement'
    )
      this.regText = 'Initial Registration Control #';
    if (this.regRequired.includes(this.requestType)) {
      this.registrationControlNumber.addValidators(Validators.required);
    }
    this.form = this.formBuilder.group({
      engagedConstruction: [''],
      registrationControlNumber: this.registrationControlNumber,
      doctypeControl: this.doctypeControl,
      recaptcha: this.recaptcha,
    });
    this.form.controls['engagedConstruction'].valueChanges.subscribe((x) => {
      console.log(x);
      if (x == 2) {
        this.errorMsg = `You are not eligible to apply for a workers' compensation exemption`;
      } else {
        this.errorMsg = '';
      }
    });
  }

  onCancel() {
    window.location.href =
      'https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry.html';
  }

  onContinue() {
    console.log(this.requestType);
    if (
      this.form.controls['engagedConstruction'].value == '1' &&
      this.form.controls['doctypeControl'].value.length > 0
    ) {
      this.isContinueClicked = true;
      const reqTypeid = this.getRequestTypeId();
      this.exemptionFillingService
        .addExemptionFilingRequest(reqTypeid,this.pendingInternalStatus, this.pendingExternalStatus)
        .subscribe(
          (res) => {
            console.log(res);
            // route = `/requestcopy/${btoa(this.requestId)}`;
            if (this.applicationType == 'Y29ycmVjdGlvbnM=') {
              this.routerService.navigate(
                ['/' + this.getRequestRoute(), btoa(res?.id)],
                { queryParams: { ica: btoa('true') } }
              );
            } else {
              this.routerService.navigate([
                '/' + this.getRequestRoute(),
                btoa(res?.id),
              ]);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  private getRequestTypeId() {
    let reqType = this.getApplicationType();
    return this.requestTypes.filter((x) => x.code == reqType)[0].id;
  }

  private getApplicationType() {
    if (this.applicationType == 'intial')
      return ApplicationTypes.InitialApplication;
    if (this.applicationType == 'renewal')
      return ApplicationTypes.RenewalApplication;
    if (this.applicationType == 'subsequent')
      return ApplicationTypes.SubsequentApplication;
    if (this.applicationType == 'reinstatement')
      return ApplicationTypes.ReinstatementsApplication;
    if (this.applicationType == 'renewalsubsequent')
      return ApplicationTypes.SubsequentRenewalApplication;
    if (this.applicationType == 'subsequentreinstatement')
      return ApplicationTypes.SubsequentReinstatementApplication;
    if (this.applicationType == 'voluntaryrevocation')
      return ApplicationTypes.VoluntaryRevocation;
    if (this.applicationType == 'requestcopy')
      return ApplicationTypes.RequestaCopy;
    if (this.applicationType == 'corrections')
      return ApplicationTypes.Corrections;
    return '';
  }

  onRequestCopy() {
    const reqTypeid = this.getRequestTypeId();
    this.addToExistingFilling(reqTypeid, '/' + this.getRequestRoute());
  }

  private addToExistingFilling(reqTypeid: number, route: any) {
    this.isContinueClicked = true;
    this.exemptionFillingService
      .getExistingExemptionFilingRequest(this.registrationControlNumber.value)
      .subscribe(
        (res) => {
          console.log(res);
          if (res && res.length > 0) {
            if(this.applicationType  == 'requestcopy' && !res[0].isActiveStatus) {
              this.errorMsg = `The registration status is not active.`;
              return;
            }
            if(this.applicationType  == 'voluntaryrevocation' && !res[0].isActiveStatus) {
              this.errorMsg = `The registration cannot be voluntarily revoked because the status is not active`;
              return;
            }
            if(this.applicationType  == 'corrections' && !res[0].isActiveStatus) {
              this.errorMsg = ` The registration cannot be corrected because the status is not active`;
              return;
            }
            this.exemptionFillingService
              .addToExistingExemptionFilingRequest(res[0].id, reqTypeid,this.pendingInternalStatus, this.pendingExternalStatus)
              .subscribe(
                (data) => {
                  console.log(data);
                  if (data && data?.id) {
                    this.routerService.navigate([route, btoa(data?.id)]);
                  }
                },
                (error) => {
                  console.log(error);
                }
              );
          } else {
            this.errorMsg = `No Worker's Compensation Exemption Registration found for: ${this.registrationControlNumber.value}`;
          }
        },
        (error) => {
          this.errorMsg = `No Worker's Compensation Exemption Registration found for: ${this.registrationControlNumber.value}`;
          console.log(error);
        }
      );
  }

  onRenwalValidation() {
    if (this.isRegValidated) {
      const reqTypeid = this.getRequestTypeId();
      this.addToExistingFilling(reqTypeid, '/' + this.getRequestRoute());
    } else {
      this.exemptionFillingService
        .getExistingExemptionFilingRequest(this.registrationControlNumber.value)
        .subscribe(
          (res) => {
            console.log(res);
            console.log('applicationType,', this.applicationType);
            console.log('requestType,', this.requestType);
            if (res && res.length > 0) {
              if (this.applicationType == 'renewal') {
                if (res[0].isActiveStatus == false) {
                  this.errorMsg = 'The registration cannot be renewed because the status is not active. Please submit a new application.';
                  return;
                }
                if (res[0].expiresIn60Days == false) {
                  this.errorMsg = 'A Renewal can only be filed within 60 days of the registration expiration date.';
                  return;
                }
              }
              if (this.applicationType == 'renewalsubsequent') {
                if (res[0].isActiveStatus == false) {
                  this.errorMsg = 'The registration cannot be renewed because the status is not active. Please submit a new application.';
                  return;
                }
                if (res[0].expiresIn60Days == false) {
                  this.errorMsg = 'A Renewal can only be filed within 60 days of the registration expiration date.';
                  return;
                }
              }
              if (this.applicationType == 'subsequentreinstatement' || this.applicationType == 'reinstatement') {
                if (res[0].isActiveStatus == false) {
                  this.errorMsg = 'Registration Control # has expired. Please enter an Initial Application.';
                  return;
                }
              }
              if(this.applicationType == "subsequent"){
                if(res[0].isActiveStatus == false){
                  this.errorMsg = 'Initial Registration Control # must be active before a related Subsequent Exemption can be entered.'
                  return;
                }
              }
              this.isRegValidated = true;
            } else {
              this.errorMsg = `No Worker's Compensation Exemption Registration found for: ${this.registrationControlNumber.value}`;
            }
          },
          (error) => {
            this.errorMsg = `No Worker's Compensation Exemption Registration found for : ${this.registrationControlNumber.value}`;
            console.log(error);
          }
        );
    }
  }

  onDocRemoved(doc: string) {
    const doctype = this.doctypeControl.value as string[];
    this.removeFirst(doctype, doc);
    this.doctypeControl.setValue(doctype);
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
}
